module.exports = __webpack_public_path__ + "static/media/BGP-CHJSeries.0b0565c6.pdf";